import { Children } from 'react';
import { IntlProvider } from 'react-intl';
import { gql, useQuery } from '@apollo/client';

const DEFAULT_LOCALE = 'en';

/* eslint react/prop-types: 0 */
const LanguageProvider = ({
  locale = DEFAULT_LOCALE,
  keys = null,
  children,
}) => {
  const { data: { translations } = {}, loading } = useQuery(TRANSLATIONS, {
    variables: { locale, keys },
    ssr: false,
  });

  if (loading || !translations) {
    return null;
  }

  return (
    <IntlProvider
      locale={locale}
      key={locale}
      messages={createTranslationMap(translations)}
      textComponent="span"
    >
      {Children.only(children)}
    </IntlProvider>
  );
};

const TRANSLATIONS = gql`
  query Translations($locale: Language!, $keys: [String]) {
    translations(language: $locale, keys: $keys, section: "authentication") {
      key
      value
    }
  }
`;

const createTranslationMap = (translations) => {
  const messages = {};

  if (translations) {
    translations.forEach((translation) => {
      if (!translation) return;

      const { key, value } = translation;

      if (key) {
        messages[key] = value;
      }
    });
  }
  return messages;
};

export default LanguageProvider;
